import React from "react";
import ProfileRegistration from "./ProfileRegistration";

export default function EditAddress() {
	return <ProfileRegistration isEdit={true} />;
}
